import React, { FunctionComponent } from 'react';

export { ListButtonsContainer } from './ListButtonsContainer';

export interface ListButtonsProps {
  Icon?: React.ElementType;
  iconClassName?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}

// ListButton is a button that is displayed as part of a list of buttons wrapped in a ListButtonsContainer.
export const ListButton: FunctionComponent<ListButtonsProps> = ({
  onClick = () => {},
  children,
  Icon,
  iconClassName
}) => {
  return (
    <li
      className="cursor-pointer rounded-lg border border-border bg-widget p-3 text-primary transition-colors hover:border-accent hover:bg-accent/40"
      onClick={onClick}
    >
      <div className="flex flex-row items-center gap-2">
        {Icon ? <Icon size={20} className={iconClassName} /> : null}
        <div>{children}</div>
      </div>
    </li>
  );
};
